/* eslint-disable */
/**
 * 背景：开发中遇到的表单输入，往往会有对输入内容的限制，比如不能输入表情和特殊字符，只能输入数字或字母等。
 * 需求：根据正则表达式，设计自定义处理表单输入规则的指令，下面以禁止输入表情和特殊字符为例
 * <input type="text" v-model="note" v-emoji />
 */
// let findEle = (parent, type) => {
//     return parent.tagName.toLowerCase() === type ? parent : parent.querySelector(type)
// }

// const trigger = (el, type) => {
//     const e = document.createEvent('HTMLEvents')
//     e.initEvent(type, true, true)
//     el.dispatchEvent(e)
// }

// const emoji = {
//     bind: function(el, binding, vnode) {
//         // 正则规则可根据需求自定义
//         var regRule = /[^u4E00-u9FA5|d|a-zA-Z|rns,.?!，。？！…—&$=()-+/*{}[]]|s/g
//         let $inp = findEle(el, 'input')
//         el.$inp = $inp
//         $inp.handle = function() {
//             let val = $inp.value
//             $inp.value = val.replace(regRule, '')

//             trigger($inp, 'input')
//         }
//         $inp.addEventListener('keyup', $inp.handle)
//     },
//     unbind: function(el) {
//         el.$inp.removeEventListener('keyup', el.$inp.handle)
//     }
// }

// export default emoji
import emojiRegex from 'emoji-regex' //npm install emoji-regex

export default {
    bind(el, binding, vnode, oldVnode) {
        const regex = emojiRegex()
        const obj = el.querySelectorAll('.el-input__inner,.el-textarea__inner')[0]
        let zclearNoNum = function(e) {
            if (e.target.composing) return
            obj.value = obj.value.trim()
            let match = regex.exec(obj.value) //也可以直接用正则表达式判断
            if (match) {
                /*for (let i=0;i<match.length;i++) {
			obj.value = obj.value.replace(match[i],"");
			}*/
                obj.value = obj.value.replace(
                    /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g,
                    ''
                )
                zclearNoNum(e)
            }
            // 触发v-model的更新
            obj.dispatchEvent(new Event('input'))
        }
        let zblur = function(e) {
            zclearNoNum(e)
            setTimeout(() => {
                obj.value = obj.value.trim()
                let match = regex.exec(obj.value)
                if (match) {
                    obj.value = obj.value.replace(
                        /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g,
                        ''
                    )
                    zclearNoNum(e)
                }
                // 触发v-model的更新
                obj.dispatchEvent(new Event('change'))
            }, 50)
        }
        obj.onkeyup = zclearNoNum
        obj.onblur = zblur

        function onCompositionStart(e) {
            e.target.composing = true
        }
        function onCompositionEnd(e) {
            e.target.composing = false
            obj.dispatchEvent(new Event('input'))
        }
        // https://segmentfault.com/a/1190000009246058
        obj.addEventListener('compositionstart', onCompositionStart)
        obj.addEventListener('compositionend', onCompositionEnd)
    },
    update(el, binding, vnode, oldVnode) {}
}
